import { render, staticRenderFns } from "./Album.vue?vue&type=template&id=fcd9b708&scoped=true&"
import script from "./Album.vue?vue&type=script&lang=js&"
export * from "./Album.vue?vue&type=script&lang=js&"
import style0 from "./Album.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Album.vue?vue&type=style&index=1&id=fcd9b708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd9b708",
  null
  
)

export default component.exports